const CruiseIcon = ({ color = "#8F9BB3", height = 24, width = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4163 3.75L16.7118 2.25H21.7502V3.75H15.4163ZM23.9998 6V7.49999H24V18.5769C24 19.0867 23.5867 19.5 23.0769 19.5H11.6505C5.2161 19.5 0 14.2839 0 7.8495C0 7.65647 0.156483 7.49999 0.349515 7.49999H5.14753L8.28386 4.21431C8.5669 3.91779 8.95897 3.75002 9.36889 3.75002H12.4434L15.2333 0.51957C15.5182 0.189647 15.9326 0 16.3685 0H22.5002C23.3286 0 24.0002 0.671573 24.0002 1.5V6H23.9998ZM9.68982 6.00002L8.25804 7.49999H21.7498V6.00002H9.68982ZM2.44221 9.74999H2.99981L2.99977 9.75002H21.75V17.25H11.6505C7.10982 17.25 3.32106 14.0307 2.44221 9.74999Z"
        fill={color}
      />
    </svg>
  )
}

export default CruiseIcon
